(function () {
    let allStores = [];
    let currentBrand = 'all';
    const storesList = document.getElementById('stores-list');
    const searchInput = document.getElementById('store-search-input');
    const searchBtn = document.getElementById('search-trigger');
    const brandFilters = document.getElementById('brand-filters');

    // Icon Pin SVG (Red)
    const pinSvg = `<svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-12-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#FF444F"/>
  </svg>`;

    async function init() {
        try {
            const response = await fetch(window.STORES_DATA_URL || '/assets/stores_data.json');
            if (!response.ok) throw new Error('Failed to load stores');
            allStores = await response.json();
            renderStores(allStores);
        } catch (err) {
            console.error(err);
            if (storesList) storesList.innerHTML = '<div class="error">Error al cargar las tiendas.</div>';
        }
    }

    function renderStores(stores) {
        if (!storesList) return;

        if (stores.length === 0) {
            storesList.innerHTML = '<div class="no-results">No se encontraron tiendas para esta selección.</div>';
            return;
        }

        const html = stores.map(store => {
            const name = store['NOMBRE TIENDA'] || 'Tienda Magic Clean';
            const address = store['DIRECCIÓN'] || '';
            const city = store['CIUDAD'] || '';
            const link = store['LINK UBICACIÓN'] || '#';
            const brand = (store['_brand'] || '').toLowerCase();
            const brandDisplay = store['_brand'] || '';

            return `
        <a href="${link}" target="_blank" class="store-card">
          <div class="store-pin">${pinSvg}</div>
          <div class="store-info">
            <span class="brand-tag ${brand}">${brandDisplay}</span>
            <h3>${name}</h3>
            <p>${address}</p>
            <p class="store-city">${city}</p>
          </div>
        </a>
      `;
        }).join('');

        storesList.innerHTML = html;
    }

    function applyFilters() {
        const term = (searchInput.value || '').toLowerCase().trim();

        const filtered = allStores.filter(store => {
            // Brand filter
            const matchesBrand = currentBrand === 'all' || store['_brand'] === currentBrand;

            // Text search filter
            const name = (store['NOMBRE TIENDA'] || '').toLowerCase();
            const address = (store['DIRECCIÓN'] || '').toLowerCase();
            const city = (store['CIUDAD'] || '').toLowerCase();
            const num = String(store['NÚM. TIENDA'] || '').toLowerCase();
            const matchesSearch = !term || (
                name.includes(term) ||
                address.includes(term) ||
                city.includes(term) ||
                num.includes(term)
            );

            return matchesBrand && matchesSearch;
        });

        renderStores(filtered);
    }

    if (searchInput) {
        searchInput.addEventListener('input', applyFilters);
    }

    if (searchBtn) {
        searchBtn.addEventListener('click', applyFilters);
    }

    if (brandFilters) {
        brandFilters.addEventListener('click', (e) => {
            if (e.target.classList.contains('filter-btn')) {
                // Update UI state
                document.querySelectorAll('.filter-btn').forEach(btn => btn.classList.remove('active'));
                e.target.classList.add('active');

                // Update current brand and filter
                currentBrand = e.target.getAttribute('data-brand');
                applyFilters();
            }
        });
    }

    init();

})();
